import axios from 'axios';
import store from '../store';

const formListRoutes = [
  'add/profile/image/'
]

const Api = axios.create({
  baseURL: process.env.LOCAL_FACADE_SERVER_FULL_ADDRESS, // Set your base URL here
  headers: {
    'Content-Type': 'application/json;charset=utf-8',
  }
});

Api.interceptors.request.use(config => {
  // Access the token from the component's state
  const authToken = store.state.user.token; // 'this' context might differ, ensure it's the correct one
  if (authToken) {
    config.headers.Authorization = `Bearer ${authToken}`;
  }
 
  if (formListRoutes.some(v => config.url.includes(v))) {
    config.headers['Content-Type'] = 'multipart/form-data';
  }
  return config;
});


Api.interceptors.response.use(
  response => {
    // Modify response data if needed
    const {config,headers,request, ...data} = response
    return data;
  },
  error => {
    // Handle error responses
    return Promise.reject(error);
  }
);

export default Api;


// WEBPACK FOOTER //
// ./src/store/api/axios.js